import React, { useContext, useEffect, useRef, useState } from 'react';
import { string } from 'prop-types';

import { ReactComponent as Logo } from 'assets/logo.svg';

import { cn } from 'utils/style';
import { SECTIONS } from 'constants/sections';
import { NavbarContext } from 'contexts/navbar';

import Link from 'components/Link';

import './styles.scss';

const navLinks = Object.values(SECTIONS).filter(item => !item.hideOnNavbar);


window.addEventListener('pushstate', () => {
  const sectionSelector = `#${window.location.pathname.slice(1)}`;
  const sectionToScrollTo = document.querySelector(sectionSelector);
  const app = document.querySelector('.app');
  const baseScreen = window.innerWidth <= 700 ? window : app;
  const offsetTop = window.innerWidth <= 700 ? 0 : 80;

  baseScreen.scrollTo({ top: sectionToScrollTo.offsetTop - offsetTop, behavior: 'smooth' });
});

function Navbar({ className, currentSection }) {
  const [activeItem, setActiveItem] = useState(currentSection);
  const linksRef = useRef(null);

  const handleClick = (event) => {
    setActiveItem(`${event.target.pathname.slice(1)}`);
  }

  useEffect(() => {
    const activeLink = linksRef.current.querySelector('.nav-link--active');

    if (activeLink) {
      const activeLinkRect = activeLink.getBoundingClientRect();
      linksRef.current.scrollTo({ left: linksRef.current.scrollLeft - linksRef.current.getBoundingClientRect().left + activeLinkRect.left, behavior: 'smooth' });
    } else {
      linksRef.current.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }, [activeItem]);

  useEffect(() => {
    setActiveItem(currentSection);
  }, [currentSection]);

  return (
    <nav className={cn('nav', activeItem !== SECTIONS.HOME.name && 'nav--with-name')}>
      <div className="nav-link nav-link--name">
        <p className="name">Enrique</p>
        <button className="theme-switch"><Logo /></button>
      </div>
      <ul className="links" ref={linksRef}>
        <div className="indicator"/>
        {navLinks.map(({ name, title }) => (
          <li key={name} className={cn('nav-link', activeItem === name && 'nav-link--active')}>
            <Link href={`${name}`} onClick={handleClick}>{title}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

Navbar.propTypes = {
  currentSection: string,
  className: string
};

function NavbarContainer(props) {
  const { currentSection } = useContext(NavbarContext);
  return <Navbar {...props} currentSection={currentSection} />
}

export default NavbarContainer;
